import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { DELETE_PROGRAM_DATA, DELETE_PROGRAM_DATA_ERROR, DELETE_PROGRAM_DATA_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* deleteProgramData({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.data?.id}`,
      method: 'DELETE',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: DELETE_PROGRAM_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DELETE_PROGRAM_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_PROGRAM_DATA_ERROR, payload: error });
  }
}

export function* watchDeleteProgramData() {
  yield takeEvery(DELETE_PROGRAM_DATA, deleteProgramData);
}

function* deleteProgramDataSaga() {
  yield all([fork(watchDeleteProgramData)]);
}

export default deleteProgramDataSaga;
